import { render, staticRenderFns } from "./trilha-sinalizacao.vue?vue&type=template&id=0c25f88d"
import script from "./trilha-sinalizacao.vue?vue&type=script&lang=js"
export * from "./trilha-sinalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports